<template>
    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">取货流程</span>
            <el-button style="float: right;margin-left:10px;" type="success" @click="popNewAddPic">新增流程</el-button>
        </div>
        <div>
            <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                border
                fit
                height="520"
                style="width: 100%">
                <el-table-column
                    prop="code"
                    header-align="center"
                    width="130"
                    label="编号">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="295"
                    label="链接">
                    <template scope="scope">
                      <el-popover
                      ref="popoverPayStatus1"
                      placement="right-start"
                      trigger="hover">
                          <img  :src="scope.row.link" style="width:220px;"/>
                      </el-popover>
                      <a style="color: #337ab7;text-decoration: none;" v-popover:popoverPayStatus1 :href="scope.row.link" target="_blank">{{scope.row.link}}</a>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="nickName"
                    header-align="center"
                    min-width="145"
                    label="创建人">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    header-align="center"
                    min-width="205"
                    label="创建时间">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    width="145"
                    label="操作">
                    <template scope="scope">
                        <el-button type="text" size="small" @click="popRemovePic(scope.row.code)" style="color:#cc0707;">删除流程</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table_pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal">
            </el-pagination>
        </div>
      </el-card>
      <po-add-pay :add-show="addPicShow" @closeAddPay="closeAddPic"></po-add-pay>
    </div>
</template>

<script>
import $axios from '../../https/config'
import poNewAddPay from '@/page/adMgr/adNewAddPay'

export default {
  data () {
    return {
      pageSize: 10,
      pageNo: 1,
      table_loading: true,
      deviceData: [],
      pageTotal: 0,
      addPicShow: false,
      curType: 0,
      multipleSelection: ''
    }
  },
  created: function () {
    this.pageNo = 1
    this.queryDeviceList()
  },
  methods: {
    queryDeviceList () {
      var params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.table_loading = true
      this.deviceData = []
      var _this = this
      $axios.get('/device/getProcessConfigList', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          var resData = []
          if (res.resultData && res.resultData.list.length > 0) {
            _this.pageTotal = res.resultData.count
            for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              var item = {
                code: itemData.id,
                link: itemData.imageUrl,
                userId: itemData.userId,
                nickName: itemData.nickName,
                createTime: itemData.createTime
              }
              resData.push(item)
            }
            _this.deviceData = resData
            _this.pageTotal = res.resultData.count
          }
        } else {
        }
        _this.table_loading = false
      }, function () {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDeviceList()
    },
    popNewAddPic (row) {
      this.addPicShow = true
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.queryDeviceList()
    },
    closeAddPic () {
      this.addPicShow = false
      this.pageNo = 1
      this.queryDeviceList()
    },
    popRemovePic (code) {
      var that = this
      var params = {
        processId: code
      }
      that.$confirm('是否删除该流程介绍：' + code, '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        $axios.get('/device/deleteDeviceProcessImg', params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
            that.queryDeviceList()
          } else {
          }
        }, function () {
          that.$message({
            type: 'error',
            message: '删除失败!'
          })
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  components: {
    'po-add-pay': poNewAddPay
  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/page/globalConfig/payStatus.vue